import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Menu from './pages/menu';
import NotFound from './pages/notfound';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Menu />} />
      <Route path="/menu" element={<Menu />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
